import {
  REMOVE_NOTIFICATION
} from './Constants';

export const changeFlagAction = () => dispatch => {
  dispatch({
    type: REMOVE_NOTIFICATION
  })
}
